var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 253,
    height: 174,
    viewBox: "0 0 253 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0H229C242.255 0 253 10.7452 253 24V150C253 163.255 242.255 174 229 174H24C10.7452 174 0 163.255 0 150V24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78 108H221V112H78V108Z",
    fill: "#BDCAD1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78 128H216V132H78V128Z",
    fill: "#BDCAD1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78 118H196V122H78V118Z",
    fill: "#BDCAD1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78 138H140V142H78V138Z",
    fill: "#BDCAD1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8965 33.4517H143.896V40.4517H77.8965V33.4517Z",
    fill: "#BDCAD1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8965 44.2539H120.896V51.2539H77.8965V44.2539Z",
    fill: "#BDCAD1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4289 70.585L87.1867 75.9949H92.875L88.2731 79.3384L90.0308 84.7483L85.4289 81.4048L80.827 84.7483L82.5847 79.3384L77.9828 75.9949H83.6711L85.4289 70.585Z",
    fill: "#FF7FFB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M126.071 70.585L127.829 75.9949H133.517L128.915 79.3384L130.673 84.7483L126.071 81.4048L121.469 84.7483L123.227 79.3384L118.625 75.9949H124.313L126.071 70.585Z",
    fill: "#FF7FFB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M105.75 70.585L107.508 75.9949H113.196L108.594 79.3384L110.352 84.7483L105.75 81.4048L101.148 84.7483L102.906 79.3384L98.3037 75.9949H103.992L105.75 70.585Z",
    fill: "#FF7FFB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M146.392 70.585L148.15 75.9949H153.838L149.236 79.3384L150.994 84.7483L146.392 81.4048L141.79 84.7483L143.548 79.3384L138.946 75.9949H144.634L146.392 70.585Z",
    fill: "#FF7FFB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M165.77 70.585L167.528 75.9949H173.216L168.614 79.3384L170.372 84.7483L165.77 81.4048L161.168 84.7483L162.926 79.3384L158.324 75.9949H164.013L165.77 70.585Z",
    fill: "#FF7FFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_812",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 15,
    width: 51,
    height: 52
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.1938H67.96V66.0801H17V15.1938Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7_812)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3694 15.063C28.2863 15.063 16.8694 26.4792 16.8694 40.563C16.8694 54.6461 28.2863 66.063 42.3694 66.063C56.4525 66.063 67.8694 54.6461 67.8694 40.563C67.8694 26.4792 56.4525 15.063 42.3694 15.063Z",
    fill: "#FF7FFB"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3694 25.5244C36.9525 25.5244 32.5613 29.9157 32.5613 35.3319C32.5613 40.7488 36.9525 45.14 42.3694 45.14C47.7863 45.14 52.1769 40.7488 52.1769 35.3319C52.1769 29.9157 47.7863 25.5244 42.3694 25.5244Z",
    fill: "#BDCAD1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3725 58.6218L59.9143 57.8686C56.4093 51.8261 49.8662 47.7549 42.3693 47.7549C34.8643 47.7549 28.3143 51.8349 24.8131 57.8886L24.7943 57.9211L24.3918 58.648C29.0025 63.2311 35.355 66.063 42.3693 66.063C49.3968 66.063 55.7606 63.2199 60.3725 58.6218Z",
    fill: "#BDCAD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.f35239c6dbf874fc0b574b073d77de40.svg";
export { ForwardRef as ReactComponent };